import { CommonTabbarContext } from "@/App";
import { getDataBoxDetail, updateDataBox } from "@/api/device/data-box";
import { getGlobalDataBoxDetail } from "@/api/lib/lib-data-box";
import { DEVICE_TYPE } from "@/enums/device-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { DataBox } from "@/global/interface/device/data-box";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import "./index.less"
import TnInput from "@/global/components/input/tn-input";
import { Skeleton, Switch } from "antd";
import TnMessage from "@/global/components/message";
import classNames from "classnames";
import React from "react";
import DataBoxDefinePanel from "./define/data-box-define";
import DataBoxCheckPanel from "./check/data-box-check";
import DataBoxModelingPanel from "./modeling/data-box-modeling";
import DataBoxInstallPanel from "./install/data-box-install";
import DataBoxCollectionPanel from "./collection/data-box-collection";
const menuNameList = [
    "设备定义",
    "建模",
    "安装/更换",
    "测试",
    "采集"
]
export default function DataBoxPanel(second) {

    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const { deviceId } = useParams()
    const [data, setData] = useState<DataBox>(null)
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeMenuIndex, setActiveMenuIndex] = useState<number>(1)

    // 标定div
    const sectionRefs = useRef([
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>()
    ])

    // 初始化
    useEffect(() => {
        if (!deviceId) return;
        getDataBoxDetail(Number(deviceId)).then(res => {
            let resDataBox: DataBox = res.data
            setData(resDataBox)
            let addTab: TabRoute = {
                title: resDataBox?.name || '',
                url: `${TAB_TYPE.DEVICE}/${deviceId}/${DEVICE_TYPE.DATA_BOX}`,
                closable: true
            }
            commonTabbarContext.pushRoute(addTab)
        })

    }, [deviceId])

    const activeMenuItem = (index: number) => {
        setActiveMenuIndex(index)
        if (sectionRefs.current[index - 1].current) {
            sectionRefs.current[index - 1].current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div className="data-box-panel-main">
            <Skeleton loading={loading}>
                <div className="detail-scroll">
                    <div ref={sectionRefs.current[0]} >
                        <DataBoxDefinePanel data={data} setData={setData} />
                    </div>
                    <div ref={sectionRefs.current[1]} >
                        <DataBoxModelingPanel dataBoxId={data?.id} />
                    </div>
                    <div ref={sectionRefs.current[2]} >
                        <DataBoxInstallPanel dataBoxId={data?.id} />
                    </div>
                    <div ref={sectionRefs.current[3]}>
                        <DataBoxCheckPanel dataBox={data} />
                    </div>
                    <div ref={sectionRefs.current[4]}>
                        <DataBoxCollectionPanel data={data} setData={setData} />
                    </div>
                </div>
            </Skeleton>
            <div className="device-menu-area">
                {menuNameList.map((item, index) => (
                    <div className="menu-item">
                        <div className="label" onClick={() => { activeMenuItem(index + 1) }}>
                            <div className={classNames({
                                "name": true,
                                "name-active": index + 1 == activeMenuIndex
                            })}>
                                {item}
                            </div>
                            <div className={classNames({
                                "circle": true,
                                "circle-active": index + 1 == activeMenuIndex
                            })} />
                        </div>
                        {index != menuNameList.length - 1 && (
                            <div className="line" />
                        )}
                    </div>
                ))}
            </div>


        </div>
    )
}